import React from 'react';
import { Banner, Layout, Paragraph, ParagraphHeader } from '@axiom/ui';
import type { CandidateEngagementDetails } from '@axiom/validation';

import { EnvUtil } from '../../utils/env-util';

export type EngagementsViewStateBannerInterviewingExpectedManualProps = {
  engagement: CandidateEngagementDetails;
  name?: string;
};

export const EngagementsViewStateBannerInterviewingExpectedManual: React.FC<
  EngagementsViewStateBannerInterviewingExpectedManualProps
> = ({
  engagement,
  name = 'ENGAGEMENTS_VIEW_STATE_BANNER_INTERVIEWING_EXPECTED_MANUAL',
}) => {
  return (
    <Banner name={name} type="critical" impact="high">
      <Layout direction="vertical" verticalGutter="24px">
        <ParagraphHeader name="INTERVIEWING_EXPECTED_MANUAL_HEADER">
          Next Step: Upcoming interview
        </ParagraphHeader>
        <Paragraph name="INTERVIEWING_EXPECTED_MANUAL_MESSAGE_1">
          An interview has been requested and we are finalizing details. Be sure
          to check your calendar or email often to see if it has been scheduled,
          and provide plenty of available times on your interview availability
          calendar.
        </Paragraph>
        <Paragraph name="INTERVIEWING_EXPECTED_MANUAL_MESSAGE_2">
          Go ahead and start preparing for your interview using{' '}
          <a href={EnvUtil.interviewGuideUrl} rel="noreferrer" target="_blank">
            Axiom's Interview Preparation Guidelines
          </a>
          .
        </Paragraph>
        {engagement.opportunity.ownerUser ? (
          <Paragraph name="INTERVIEWING_EXPECTED_MANUAL_MESSAGE_3">
            Questions about interview details or have last-minute issues? Reach
            out to{' '}
            <a href={`mailto:${engagement.opportunity.ownerUser.email}`}>
              {engagement.opportunity.ownerUser.fullName}
            </a>
            .
          </Paragraph>
        ) : null}
      </Layout>
    </Banner>
  );
};
